// removed by extract-text-webpack-plugin
module.exports = {"btn-post-demand":"btn-post-demand","post-demand-text":"post-demand-text","cart-count":"cart-count"};


//////////////////
// WEBPACK FOOTER
// ./components/layouts/master/sub-header/_ShoppingCart.scss
// module id = ./components/layouts/master/sub-header/_ShoppingCart.scss
// module chunks = 0